import { Injectable } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ApplicationService, ParcelAppEntityApplicationRead, ParcelAppEntityParcelRead, ParcelAppEntityParcelWrite,
  ParcelService
} from '../openapi';
import { forkJoin, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ParcelsCommonService {
  constructor(
    private parcelService: ParcelService,
    private applicationService: ApplicationService
  ) {
  }

  public updateParcels(
    currentApp: ApplicationAppEntityApplicationRead,
    payload: ApplicationAppEntityApplicationWrite,
    parcels: ParcelAppEntityParcelWrite[],
    tag: string = 'parcels'
  ): Observable<ApplicationAppEntityApplicationRead> {
    if (parcels.length) {
      const oldIds: string[] = currentApp?.parcels
        ?.filter(v => v?.tag === tag)
        ?.map((p: ParcelAppEntityApplicationRead) => p?.uuid || '') || [];

      const deleteRequest: Observable<any> = oldIds?.length ? forkJoin(oldIds.map(id => this.parcelService.deleteParcelParcelItem({ id }))) : of([]);
      return deleteRequest.pipe(
        switchMap(() => {
          return forkJoin(
            parcels.map(parcel =>
              this.parcelService.postParcelParcelCollection({
                parcel: {
                  ...parcel,
                  tag
                }
              })
            )
          ).pipe(
            switchMap((p: ParcelAppEntityParcelRead[]) =>
              this.applicationService.patchApplicationApplicationItem({
                id: currentApp?.uuid || '',
                application: {
                  ...payload,
                  parcels: [
                    ...p.map(v => v?.uuid || ''),
                    ...(currentApp?.parcels?.filter(v => v?.tag !== tag)?.map(v => v?.uuid || '') || [])
                  ]
                }
              })
            )
          );
        })
      );
    } else {
      return this.applicationService.patchApplicationApplicationItem({
        id: currentApp?.uuid || '',
        application: payload
      });
    }
  }
}
